import { useStore } from "hooks/use-store";
import { useEffect } from "react";

/*
Benchmarks:

My laptop     10000
Garmin        1500
Device (HDMI) 1049 
Raymarine     441
Furuno        190
Simrad        26-131 (varies)
*/

const getBrowserSpeed = (measurePeriod = 100) => {
  let count = 0;
  if (typeof performance === "undefined") {
    const start = Date.now();
    while (Date.now() - start < measurePeriod) {
      count++;
    }
  }

  const start = performance.now();
  while (performance.now() - start < measurePeriod) {
    count++;
  }

  const opsPerMs = count / measurePeriod;

  return Math.round(opsPerMs);
};

export const useBrowserSpeed = () => {
  const setBrowserSpeed = useStore((state) => state.setBrowserSpeed);

  const updateBrowserSpeed = () => {
    const browserSpeed = getBrowserSpeed();
    setBrowserSpeed(browserSpeed);
  };

  // Tick that triggers update every minute
  useEffect(() => {
    // Initial update
    updateBrowserSpeed();

    // Update regularly
    const interval = setInterval(() => {
      updateBrowserSpeed();
    }, 600_000);

    return () => {
      clearInterval(interval);
    };
  }, []);
};
